/**
 * מודאל הורדת אפליקציה (business-sites): זיהוי מכשיר, הודעה מותאמת, שני כפתורי חנות תמיד זמינים.
 */
(function () {
  "use strict";

  /**
   * @returns {'ios' | 'android' | 'other'}
   */
  function detectPlatform() {
    var ua = navigator.userAgent || "";
    if (/Android/i.test(ua)) return "android";
    if (/iPad|iPhone|iPod/i.test(ua)) return "ios";
    if (
      typeof navigator.platform === "string" &&
      navigator.platform === "MacIntel" &&
      navigator.maxTouchPoints > 1
    ) {
      return "ios";
    }
    return "other";
  }

  function applyStoreHref(anchor, url) {
    if (!anchor) return;
    var trimmed = (url || "").trim();
    if (trimmed) anchor.setAttribute("href", trimmed);
  }

  function resetButtonStyles(iosBtn, androidBtn) {
    var btns = [iosBtn, androidBtn];
    for (var i = 0; i < btns.length; i++) {
      var b = btns[i];
      if (!b) continue;
      b.classList.remove(
        "btn-primary",
        "btn-dark",
        "text-white",
        "btn-outline-primary",
        "btn-outline-secondary",
        "btn-outline-dark"
      );
      b.classList.add("btn-outline-dark");
    }
  }

  function styleForPlatform(platform, iosBtn, androidBtn) {
    resetButtonStyles(iosBtn, androidBtn);
    if (platform === "ios" && iosBtn && androidBtn) {
      iosBtn.classList.remove("btn-outline-dark");
      iosBtn.classList.add("btn-dark", "text-white");
      androidBtn.classList.remove("btn-outline-dark");
      androidBtn.classList.add("btn-outline-secondary");
    } else if (platform === "android" && iosBtn && androidBtn) {
      androidBtn.classList.remove("btn-outline-dark");
      androidBtn.classList.add("btn-dark", "text-white");
      iosBtn.classList.remove("btn-outline-dark");
      iosBtn.classList.add("btn-outline-secondary");
    }
  }

  function hintText(platform) {
    if (platform === "ios") {
      return "זיהינו מכשיר Apple — מומלץ להוריד מחנות האפליקציות של אפל. עדיין אפשר לבחור גם את Google Play למטה.";
    }
    if (platform === "android") {
      return "זיהינו מכשיר Android — מומלץ להוריד מ-Google Play. עדיין אפשר לבחור גם את חנות אפל למטה.";
    }
    return "לא זיהינו מכשיר נייד ספציפי — בחרו את החנות המתאימה (iPhone או Android).";
  }

  function initBusinessAppDownloadModal() {
    var modalEl = document.getElementById("businessAppDownloadModal");
    if (!modalEl) return;

    var iosBtn = modalEl.querySelector(".br-app-dl__btn--ios");
    var androidBtn = modalEl.querySelector(".br-app-dl__btn--android");
    var hintEl = document.getElementById("br-app-dl-hint");

    var iosUrl = modalEl.getAttribute("data-ios-url") || "";
    var androidUrl = modalEl.getAttribute("data-android-url") || "";
    applyStoreHref(iosBtn, iosUrl);
    applyStoreHref(androidBtn, androidUrl);

    modalEl.addEventListener(
      "shown.mdb.modal",
      function () {
        var platform = detectPlatform();
        if (hintEl) {
          hintEl.textContent = hintText(platform);
        }
        styleForPlatform(platform, iosBtn, androidBtn);
      },
      false
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBusinessAppDownloadModal, { once: true });
  } else {
    initBusinessAppDownloadModal();
  }
})();
